import { MouseEvent, ReactNode } from 'react'

import { KebabMenuItemLi } from './styles'

interface KebabMenuItemProps {
  title: ReactNode
  onClick: (ev: MouseEvent) => void
}

const KebabMenuItem = ({ title, onClick }: KebabMenuItemProps) => {
  return <KebabMenuItemLi onClick={onClick}>{title}</KebabMenuItemLi>
}

export default KebabMenuItem
